module.exports = __webpack_public_path__ + "static/media/book2.441b083b.svg";